import Linkify from "linkify-react";
import React from "react";
import { IoWarningOutline } from "react-icons/io5";
import { MdOutlineSpeakerNotes } from "react-icons/md";

export const ShowEventNotes = ({
    title,
    info,
}: {
    title: string;
    info: string;
}) => {
    if (!info) return null;

    const infoWithLineBreaks = info.split("\n").map((line, index, array) => (
        <React.Fragment key={index}>
            {line}
            {index < array.length - 1 && index > 0 && <br />}{" "}
            {/* Add <br /> after every line except the last and the first*/}
        </React.Fragment>
    ));

    return (
        <div className="w-full rounded-xl border border-v3-N-500 bg-v3-N-600/50 px-4 py-3">
            <div className="flex w-full flex-col items-start justify-center gap-3">
                <h2 className="flex gap-2 text-sm font-semibold leading-4 tracking-wider text-white/80">
                    <MdOutlineSpeakerNotes />
                    <span>{title}</span>
                </h2>

                <p className="break-words tracking-wider text-white">
                    <Linkify>{infoWithLineBreaks}</Linkify>
                </p>
            </div>
        </div>
    );
};
